module.exports = __webpack_public_path__ + "img/image-one.eb022a7d.jpg";